<template>
  <div class="home" v-loading="loading">
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-slide slide-one">
        <div class="page">
          <h3>{{ company }}</h3>
          <p>best for beauty</p>
        </div>
        <p class="slogan">做专业的健康体重管理公司</p>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-two">
        <div class="page">
          <h3>未来规划</h3>
          <p>Suecessful Cass</p>
        </div>
        <ul class="case-item">
          <li
              v-for="(item,index) in caseList"
              :key="index"
              v-lazy:background-image="imgserver + item.Img"
          >
            <router-link
                class="text-decoration"
                :to="{ name: 'casedetails', params: { id: item.Id }}"
            >
              <div class="case-item-hover">
                <p class="hover-title">{{ item.Title }}</p>
                <div class="bottom"></div>
                <div class="more">
                  <span>MORE</span>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-three">
        <div class="page">
          <h3>最新资讯</h3>
          <p>Latest News</p>
        </div>
        <div class="news-content">
          <div class="news-content-item" v-for="(news,i) in newsList" :key="i">
            <div :style="'order: '+ (i%2==0 ? 1: 3)">
              <!--              <router-link-->
              <!--                class="text-decoration"-->
              <!--                :to="{ name: 'newsdetails', params: { id: news.Id }}"-->
              <!--              >-->
              <!--                <div class="item-img" v-lazy:background-image="news.Img"></div>-->
              <!--              </router-link>-->

              <el-image :src="news.Img"></el-image>

            </div>
            <div style="order: 2">
              <el-divider>
                <i class="el-icon-apple"></i>
              </el-divider>
            </div>
            <div class="item-content" :style="'order: '+ (i%2==0 ? 3: 1)">
              <h3>{{ news.Title }}</h3>
              <p>{{ news.Content }}</p>
              <span>{{ news.CreateTime }}</span>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import {swiper, swiperSlide} from "vue-awesome-swiper";

export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      loading: true,
      caseList: [],
      newsList: [],
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: false, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: false, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight - 60, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,

        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          // slideChange: () => {
          //   let swiper = this.$refs.mySwiper.swiper;
          //   //console.log(swiper.activeIndex); //滑动打印当前索引
          //   if (swiper.activeIndex === this.list.length - 1) {
          //     //到最后一个加载更多数据
          //     let newList = [];
          //     let listLength = this.list.length;
          //     for (let i = 0; i < 10; i++) {
          //       newList.push(listLength + i);
          //     }
          //     this.list = this.list.concat(newList);
          //   }
          // }
        }
      }
    };
  },
  created() {

  },
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {

    this.caseList = [
      {
        "Id": 29,
        "Img": "/imagestore/2020/0605/439332ec-11c0-440c-8800-d94b0479c22c.jpg",
        "Title": "上海市公共安全教育实训基地项目位",
        "Content": "位于上海市青浦区沪青平公路6888号“东方绿舟”东南 角，四界范围为：东临城市河道，南至沪青平公路，西界绿湖路，北靠现有的东方绿舟停机 坪。项目用地面积65048平方米（以实测为准），新建总建筑面积约为26467平方米（地上 23500平方米，地下2967平方米）",
        "Del": null,
        "CreateTime": "2020-06-05T21:12:45.387"
      },
      {
        "Id": 28,
        "Img": "/imagestore/2020/0605/fcebfcd1-7b8c-4214-9fc4-c9c275ccaaf0.jpg",
        "Title": "高端装备用特种电缆检测评估服务基地",
        "Content": "高端装备用特种电缆检测评估服务基地建设 一期工程位于上海市宝山区山连路558号， 项目建筑面积为19324.03平方米（地上建 筑面积为15446.74平方米，地下建筑面积\n为3877.29平方米）。",
        "Del": null,
        "CreateTime": "2020-06-05T21:05:45.157"
      },
      {
        "Id": 27,
        "Img": "/imagestore/2020/0605/e6cad4d5-0f76-4241-a112-8660acf8c281.jpg",
        "Title": "中国移动上海公司临港数据中心",
        "Content": "上海移动临港IDC研发与产业化基地项目一 期数据中心2#机楼微模块机房配套工程",
        "Del": null,
        "CreateTime": "2020-06-05T21:02:05.567"
      },
      {
        "Id": 26,
        "Img": "/imagestore/2020/0605/0c6fa4a8-94da-4fc5-bac4-76c59d52c2b2.jpg",
        "Title": "上海合作组织国际司法交流培训基地项目",
        "Content": "上海合作组织国际司法交流合作培训基地（上海政法学院）工程位于松江区泗陈公路5488号\n上海政法学院东南部，项目用地面积66125平方米（以实测为准），新建总建筑面积约为 24976平方米，其中地上建筑面积为22476平方米，地下建筑面积约为2500平方米。",
        "Del": null,
        "CreateTime": "2020-06-05T20:58:05.57"
      }
    ]

    this.newsList = [
      {
        "Id": 19,
        "Title": "Hello，BFB！未来更美好！",
        "Img": "data:image/jpeg;base64,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",
        "Type": 1,
        "Content": "继3月13日，BFB集团位于广州市白云区泰信智汇直播基地5楼的多燕瘦私域中心正式启用。随着BFB集团的发展壮大，BFB集团又选址了位于泰信智汇直播基地3楼和4楼作为新办公室。经过两个多月如火如荼的装修，2022年7月13日，BFB集团迎来了这重要的日子一一乔迁新办公室。",
        "CreateTime": "2022-07-22 20:55:46"
      },
      {
        "Id": 15,
        "Title": "夏季防暑指南，请趁“热”查收！",
        "Img": "data:image/jpeg;base64,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",
        "Type": 1,
        "Content": "中暑的医学定义是指高温环境下由于热平衡和/或水盐代谢紊乱等而引起的一种以中枢神经系统和循环系统障碍为主要表现的急性疾病。气温过高、湿度大、风速小、体弱、对热不适应、劳动强度过大和时间过长、过度疲劳等都易诱发中暑。",
        "CreateTime": "2022-07-25 21:23:56"
      }
    ]
    this.loading = false;
    // this.$http
    //   .all([
    //     this.$http.get("Cases/GetCasesAll"),
    //     this.$http.get(`News?type=1&num=3`)
    //   ])
    //   .then(
    //     this.$http.spread((responseCases, responseNews) => {
    //       this.caseList = responseCases.data;
    //       this.newsList = responseNews.data;
    //       this.loading = false;
    //     })
    //   );
  }
};
</script>

<style lang="scss" scoped>
/* .el-header {
  position: absolute;
} */
.swiper-slide {
  font-size: 24px;
  text-align: center;
  line-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  .page {
    text-align: center;
    height: 100px;
    overflow: hidden;

    h3,
    p {
      font-size: 40px;
      font-weight: 400;
      color: #fff;
    }
  }

  .slogan {
    text-align: center;
    font-size: 50px;
    color: #fff;
    padding: 30px 0;
  }
}

//经典案例
.case-item {
  width: 1100px;
  height: 500px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  li {
    width: 330px;
    height: 250px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;

    &:hover {
      .case-item-hover {
        opacity: 1;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}

//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  background-color: rgba(225, 56, 52, 0.7);

  .hover-title {
    height: 50px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 20px;
  }

  .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
  }

  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 100px;
    border: 2px solid #fff;

    span {
      color: #fff;
      font-size: 20px;
    }
  }
}

.slide-one {
  background: url(../assets/img/gz-3.jpg) no-repeat center;
  background-size: cover;
}

.slide-two {
  background: url(../assets/img/gz-2.jpeg) no-repeat center;
  background-size: cover;
}

.slide-three {
  background: url(../assets/img/home_anli.jpg) no-repeat center;
  background-size: cover;
}

//最新资讯
.news-content {
  width: 1240px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: center;

  &-item {
    width: 400px;
    display: flex;
    flex-direction: column;

    .item-img {
      width: 360px;
      height: 230px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-origin: content-box;
      margin: 0 auto;
    }

    .el-divider {
      background-color: #fff;
      height: 3px;

      .el-divider__text {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0px;
        color: #fff;
      }
    }

    .item-content {
      width: 360px;
      height: 230px;
      margin: 0 auto;
      //border: 1px solid paleturquoise;
      h3 {
        font-size: 22px;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      p {
        font-size: 15px;
        height: 80px;
        overflow: hidden;
        margin: 10px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
      }

      span {
        display: block;
        font-size: 14px;
        text-align: end;
      }

      h3,
      p,
      span {
        color: #fff;
      }
    }
  }
}

.order {
  order: -1;
}

.order-img {
  order: 1;
}
</style>
